import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
// import { Translations } from 'src/app/core/models';
import { navigation } from 'src/app/core/translations/navigation';
import { environment } from 'src/environments/environment';
import { ModalVideoComponent } from '../components';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent  implements OnInit {
  @ViewChild('videoPlayer') videoplayer!: ElementRef;
  isHandsetPortrait: boolean = false;
  bannerImage: any ='';
  bannerClass: any ='';
  safeURL : SafeResourceUrl ='';
  currentLanguage: string = '';
  languageTranslations: any = navigation;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute, 
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer
    ) {}

  ngOnInit(): void {


    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
      'https://www.youtube.com/embed/O1HPaVLS3K8'
    );

    if(this.route.snapshot.paramMap.get('language') == 'panjabi'){

      this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(
        'https://www.youtube.com/embed/opKYpOacZW8'
      );

    }
    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;

    if (this.route.snapshot.paramMap.get('language')) {
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        // console.log(this.activeLanguageTranslations);
      }
    }
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }
  openVideoPopup(): void {
    // this.videoplayer?.nativeElement.play();
      this.dialog.open(ModalVideoComponent, {
        data: { videoURL:'https://www.youtube.com/embed/dquXIBZiizc' },
      });
  }
  
}
